/*
 * Copyright (c) 2023. Collabro Limited
 */
import React from "react";
import { Chip, Stack, Tooltip, Typography } from "@mui/material";
import { DateTime } from "luxon";
import { Total, Traffic } from "RosterData";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";

interface DateColumnProps {
  date: DateTime;
  showTotals: boolean;
  total: Total | null;
  traffic: Traffic | null;
}

const DateColumn = (props: DateColumnProps) => {
  return (
    <Stack
      spacing={0.3}
      direction="row"
      useFlexGap
      flexWrap="wrap"
      alignItems="center"
      justifyContent="center"
    >
      <Typography variant="caption">{props.date.weekdayShort}</Typography>
      <Typography variant="caption">{props.date.toFormat("dd/LL")}</Typography>
      {props.traffic && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Tooltip title="Arriving" placement="top">
            <Chip
              size="small"
              sx={{ mr: 0.1 }}
              icon={<ArrowDownward />}
              label={props.traffic.out}
              variant="outlined"
            />
          </Tooltip>
          <Tooltip title="Departing" placement="top">
            <Chip
              size="small"
              icon={<ArrowUpward />}
              label={props.traffic.in}
              variant="outlined"
            />
          </Tooltip>
        </div>
      )}
      {props.showTotals && (
        <Chip
          sx={{ width: "100%" }}
          variant="outlined"
          label={`POB: ${props.total ? props.total.total : 0}`}
          size="small"
        />
      )}
    </Stack>
    // <div
    //   style={{
    //     display: "flex",
    //     flexDirection: "column",
    //     width: "100%",
    //   }}
    // >
    //   <div
    //     style={{
    //       display: "flex",
    //       justifyContent: "center",
    //     }}
    //   >
    //     <Typography variant="subtitle2" sx={{ textAlign: "center" }}>
    //       {props.date.weekdayShort} {props.date.toFormat("dd/LL")}
    //     </Typography>
    //   </div>
    //   {props.traffic && (
    //     <div
    //       style={{
    //         display: "flex",
    //         justifyContent: "space-between",
    //       }}
    //     >
    //       <Tooltip title="Inbound" placement="top">
    //         <Chip
    //           variant="outlined"
    //           icon={<ArrowDownward />}
    //           label={props.traffic.in}
    //           size="small"
    //         />
    //       </Tooltip>
    //       <Tooltip title="Outbound" placement="top">
    //         <Chip
    //           variant="outlined"
    //           icon={<ArrowUpward />}
    //           label={props.traffic.out}
    //           size="small"
    //         />
    //       </Tooltip>
    //     </div>
    //   )}
    //   {props.showTotals && (
    //     <Chip
    //       variant="outlined"
    //       sx={{ mt: 0.5 }}
    //       label={`POB: ${props.total ? props.total.total : 0}`}
    //       size="small"
    //     />
    //   )}
    // </div>
  );
};

export default DateColumn;
